import type { QuoteRecord } from '../types';

/** Merge API quotes with local storage (preserves emailsSent from local when present). */
export function mergeQuotes(apiRows: QuoteRecord[], localRows: QuoteRecord[]): QuoteRecord[] {
  const byId = new Map<string, QuoteRecord>();
  for (const q of localRows) byId.set(q.id, q);
  for (const q of apiRows) {
    const prev = byId.get(q.id);
    byId.set(
      q.id,
      prev
        ? {
            ...prev,
            ...q,
            paymentStatus:
              prev.paymentStatus === 'paid' || q.paymentStatus === 'paid' ? 'paid' : (q.paymentStatus ?? prev.paymentStatus),
            emailsSent: { ...prev.emailsSent, ...q.emailsSent },
          }
        : q,
    );
  }
  return Array.from(byId.values());
}
